import * as React from 'react';
import { Link, makeStyles, MenuDivider, shorthands, tokens } from '@fluentui/react-components';
import { defineMessage, useIntl } from 'react-intl';

export interface SupportLinksProp {
  children?: React.ReactNode;
}

export function SupportLinks({ children }: SupportLinksProp) {
  const intl = useIntl();
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <MenuDivider />
      {children ? children : <span className={classes.label}>{intl.formatMessage(resourcesLabel)}</span>}
      <Link href="https://aka.ms/startuphelp-benefits" target="_blank" className={classes.link}>
        {intl.formatMessage(programBenefitsLabel)}
      </Link>
      <Link href="https://aka.ms/startuphelp-mfs-portal" target="_blank" className={classes.link}>
        {intl.formatMessage(mfsPortalLabel)}
      </Link>
      <Link href="https://aka.ms/startuphelp-other" target="_blank" className={classes.link}>
        {intl.formatMessage(otherLabel)}
      </Link>
    </div>
  );
}

const resourcesLabel = defineMessage({
  defaultMessage: 'Resources',
  description: 'header for resources section',
});

const programBenefitsLabel = defineMessage({
  defaultMessage: 'Program benefits',
  description: 'nav link to program benefits information',
});

const mfsPortalLabel = defineMessage({
  defaultMessage: 'Microsoft for Startups portal',
  description: '{Locked="Microsoft for Startups"}, nav link to Microsoft for Startups portal',
});

const otherLabel = defineMessage({
  defaultMessage: 'Other',
  description: 'nav link to other information',
});

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  link: {
    ...shorthands.margin(tokens.spacingVerticalS, 0),
  },
  label: {
    ...shorthands.margin(tokens.spacingVerticalL, 0),
  },
});
